import { useEffect, useState } from "react";
import { registerSW } from "virtual:pwa-register";

declare const __APP_VERSION__: string;

async function clearLegacyCaches() {
  try {
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(
        keys
          .filter((k) => /^nanom-wallet-pwa-v\d+/i.test(k) || k === "nanom-wallet-pwa-v56")
          .map((k) => caches.delete(k))
      );
    }
  } catch {
    /* ignore */
  }
}

export function PwaUpdateBanner() {
  const [needRefresh, setNeedRefresh] = useState(false);
  const [updateSW, setUpdateSW] = useState<((reload?: boolean) => Promise<void>) | null>(
    null
  );

  useEffect(() => {
    void clearLegacyCaches();
    const upd = registerSW({
      immediate: true,
      onNeedRefresh() {
        setNeedRefresh(true);
      },
      onOfflineReady() {
        /* silent */
      },
    });
    setUpdateSW(() => upd);
  }, []);

  if (!needRefresh || !updateSW) return null;

  return (
    <div className="pwa-update" role="status">
      <div className="pwa-update-card">
        <span>v{typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : ""}</span>
        <button
          type="button"
          className="primary narrow"
          onClick={() => {
            void updateSW(true);
          }}
        >
          به‌روزرسانی
        </button>
      </div>
    </div>
  );
}
